import { Link } from "react-router-dom";
import { channels } from "@/mocks/channels";
import { articlesByChannel } from "@/mocks/articles";
import { toneSoft, toneText } from "@/utils/display";

export default function ChannelSection() {
  return (
    <section aria-labelledby="channels-heading" className="container-page py-14">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <span className="text-xs font-medium tracking-[0.2em] text-primary-600">SECTIONS</span>
          <h2 id="channels-heading" className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            栏目导航
          </h2>
          <p className="mt-2 max-w-xl text-sm leading-relaxed text-foreground-600">
            六个固定栏目，分别对应不同的观察视角。每个栏目只收录同一类逻辑的档案，方便你顺着线索往下读。
          </p>
        </div>
        <Link
          to="/channels"
          className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-800"
        >
          栏目总览
          <i className="ri-arrow-right-line" aria-hidden="true" />
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {channels.map((c) => {
          const count = articlesByChannel(c.slug).length;
          return (
            <Link
              key={c.slug}
              to={`/channel/${c.slug}`}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200"
            >
              <div className="flex items-center justify-between">
                <span className={`flex h-11 w-11 items-center justify-center rounded-md ${toneSoft[c.tone]}`}>
                  <i className={`${c.icon} text-xl`} aria-hidden="true" />
                </span>
                <span className="text-xs text-foreground-400">{count} 篇档案</span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{c.name}</h3>
              <p className={`mt-1 text-xs font-medium ${toneText[c.tone]}`}>{c.tagline}</p>
              <p className="mt-3 line-clamp-3 flex-1 text-sm leading-relaxed text-foreground-600">
                {c.description}
              </p>
              <span className="mt-4 flex items-center gap-1 text-xs font-medium text-foreground-700 transition-colors group-hover:text-primary-700">
                进入栏目
                <i className="ri-arrow-right-line" aria-hidden="true" />
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}